export const STAF_SEND_OTP = "public/staff-send-otp";
export const SEND_OTP = "public/send-otp";
export const SEND_ONBORAD_DOCTOR_OTP = "public/send-onboard-doctor-OTP";
export const DOCTOR_LOGIN_WITH_PASSWORD_OR_OTP = "/auth/login-rev2";
